import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a9cd4d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "viesti",
  class: "FrontPage"
}
const _hoisted_2 = { class: "Introduction clearfix NormalPaddings" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Yksisarviset kiittävät", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Kiitos luottamuksestasi meihin, ja kiinnostuksestasi.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Meille on ilo ja kunnia olla kiinnostuksesti kohde.", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Saat meidät luoksesi pyytäen puhtautta sydämen ja mielen. Siihen pyrkien ja sitä pyytäen 💝 ", -1))

import UnicornMessage from "../components/UnicornMessage.vue";
import HomeButton from "../components/HomeButton.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(UnicornMessage)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _createVNode(HomeButton)
    ])
  ]))
}
}

})